module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAGCAYAAAD68A/GAAAAVElEQVQImW3KwQmAMBBE0R+wAytKEd7FQ072ICknVViQpAcZYhZZ9p9m4KX9KCewApW4C+gL0ID7Mx4LbUAWfDQCbEhGUHmsDOlMGGFDHv7x3CPgBR7LE65mREvJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xia.png
// module id = kFhA
// module chunks = 94